import { takeLatest, put, call } from 'redux-saga/effects';
import { storage } from '@commons';

import {
    NEW_FILTER_PRODUTO_INSUMO,
    NEW_FILTER_PRODUTO_INSUMO_PENDING,
    NEW_FILTER_PRODUTO_INSUMO_SUCCESS,
    NEW_FILTER_PRODUTO_INSUMO_FAILURE,
    CONFIG_SESSION,
    PRODUTO_INSUMO_GRUPO_DEFENSIVO_ENUM,
    PRODUTO_INSUMO_GRUPO_ITEM_ENUM,
    PRODUTO_INSUMO_GRUPO_CULTIVAR_ENUM,
    PRODUTO_INSUMO_GRUPO_FERTILIZANTE_ENUM,
} from '@handler';
import { filterProdutoInsumo } from '../service';
import { 
    CONST_FILTER_PRODUTO_INSUMO, 
    CONST_ROWS_PER_PAGE,
} from '@commons/consts';
import { PRODUTO_INSUMO_CATEGORIA_ENUM } from '../produtoInsumoCategoriaEnum';

function* sagaNewFilterProdutoInsumo(action) {
    try {
        yield put({ type: NEW_FILTER_PRODUTO_INSUMO_PENDING })

        const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;

        let where = '';
        const filterSaved = JSON.parse(sessionStorage.getItem(CONST_FILTER_PRODUTO_INSUMO)) || null;
        
        let newFilter = {
            status: null,
            descricao: '',
            categoria: null,
            grupo: null,
            rows: filterSaved?.rows || CONST_ROWS_PER_PAGE,
            page: filterSaved?.page || 0,
            where: ''
        };

        // Se estiver setando um novo filtro
        if (action.newFilter) {
            // Quando aplica um novo filtro, volta para a primeira página
            // mas mantém o número de registros por página selecionado pelo usuário
            newFilter.page = 0;
            
            if (action.args.status !== null) {
                where += `&status=${action.args.status === 'S' ? true : false}`;
            }
            if (action.args.descricao !== null && action.args.descricao !== '') {
                where += `&descricao=${action.args.descricao}`;
            }
            if (action.args.categoria !== null) {
                const categorias = PRODUTO_INSUMO_CATEGORIA_ENUM;
                where += `&categoria=${(categorias.find(element => element.id === action.args.categoria).idBD ?? -1)}`;
            }
            
            if (action.args.categoria !== null && 
                action.args.categoria !== 'COMBUSTIVEL' && 
                action.args.categoria !== 'OUTROS') {
                
                let grupos;
                
                if (action.args.grupo !== null) {
                    switch (action.args.categoria) {
                        case 'DEFENSIVO':
                            grupos = PRODUTO_INSUMO_GRUPO_DEFENSIVO_ENUM;
                            break;
                        case 'FERTILIZANTE':
                            grupos = PRODUTO_INSUMO_GRUPO_FERTILIZANTE_ENUM;
                            break;
                        case 'CULTIVAR':
                            grupos = PRODUTO_INSUMO_GRUPO_CULTIVAR_ENUM;
                            break;
                        case 'ITEM':
                            grupos = PRODUTO_INSUMO_GRUPO_ITEM_ENUM;
                            break;
                    }
                    
                    if (grupos) {
                        where += `&grupo=${(grupos.find(element => element.id === action.args.grupo).idBD ?? -1)}`;
                    }
                }
            }

            newFilter = {
                ...newFilter,
                ...action.args,
                where: where
            };
        } 
        // Se estiver usando um filtro salvo
        else if (filterSaved) {
            // Preserva TODAS as configurações salvas, incluindo page e rows
            if (filterSaved.status !== null) {
                where += `&status=${filterSaved.status === 'S' ? true : false}`;
            }
            if (filterSaved.descricao !== null && filterSaved.descricao !== '') {
                where += `&descricao=${filterSaved.descricao}`;
            }
            if (filterSaved.categoria !== null) {
                const categorias = PRODUTO_INSUMO_CATEGORIA_ENUM;
                where += `&categoria=${(categorias.find(element => element.id === filterSaved.categoria).idBD ?? -1)}`;
            }
            
            if (filterSaved.categoria !== null && 
                filterSaved.categoria !== 'COMBUSTIVEL' && 
                filterSaved.categoria !== 'OUTROS') {
                
                let grupos;
                
                if (filterSaved.grupo !== null) {
                    switch (filterSaved.categoria) {
                        case 'DEFENSIVO':
                            grupos = PRODUTO_INSUMO_GRUPO_DEFENSIVO_ENUM;
                            break;
                        case 'FERTILIZANTE':
                            grupos = PRODUTO_INSUMO_GRUPO_FERTILIZANTE_ENUM;
                            break;
                        case 'CULTIVAR':
                            grupos = PRODUTO_INSUMO_GRUPO_CULTIVAR_ENUM;
                            break;
                        case 'ITEM':
                            grupos = PRODUTO_INSUMO_GRUPO_ITEM_ENUM;
                            break;
                    }
                    
                    if (grupos) {
                        where += `&grupo=${(grupos.find(element => element.id === filterSaved.grupo).idBD ?? -1)}`;
                    }
                }
            }

            newFilter = {
                ...filterSaved,
                where: where
            };
        }

        const list = yield call(filterProdutoInsumo, idFazenda, `&page=${newFilter.page}&size=${newFilter.rows}${where}`);

        sessionStorage.setItem(CONST_FILTER_PRODUTO_INSUMO, JSON.stringify(newFilter));
        yield put({
            type: NEW_FILTER_PRODUTO_INSUMO_SUCCESS, list: list, filter: newFilter
        });
    } catch (error) {
        yield put({ type: NEW_FILTER_PRODUTO_INSUMO_FAILURE });
    }
}

export default function* watchNewFilterProdutoInsumo() {
    yield takeLatest(NEW_FILTER_PRODUTO_INSUMO, sagaNewFilterProdutoInsumo);
}
